import { render } from "./TransactionsGrid.vue?vue&type=template&id=3fb89b5a&scoped=true"
import script from "./TransactionsGrid.vue?vue&type=script&lang=js"
export * from "./TransactionsGrid.vue?vue&type=script&lang=js"

import "./TransactionsGrid.vue?vue&type=style&index=0&id=3fb89b5a&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-3fb89b5a"

export default script